/**
 * The saved shape of a chart, and the shape of the result it produces.
 *
 * A chart, a pivot table and a stat tile are the same thing at different
 * sizes: a cross-tab with two, one or zero dimensions. Keeping one spec and
 * one result shape is what stops "the chart says 41 and the pivot says 43".
 *
 * Both are plain and fully serializable — no methods, no Maps — because a spec
 * is stored as JSON and a result crosses the GraphQL boundary.
 *
 * Survey answers are categorical or free text; no question type stores a
 * number and options carry no weight. Averages, scores, NPS and trends of a
 * score are therefore not computable, and no Measure below offers them.
 */
export const CHART_SPEC_VERSION = 1;
/**
 * A well-formed result with nothing in it. Used for a spec that could not be
 * run, so callers indexing the results array by position still find an object
 * of the right shape where the failure was.
 */
export const emptyChartResult = (error, now = new Date()) => ({
    rowKeys: [],
    colKeys: [],
    rowLabels: [],
    colLabels: [],
    cells: [],
    totals: { rows: {}, columns: {}, grand: null, incomplete: false },
    meta: {
        respondentsInScope: 0,
        baseRespondents: 0,
        notApplicableRespondents: 0,
        naWithSelections: 0,
        versionsCovered: [],
        multiValueDimensions: [],
        minCellCount: 0,
        suppressedCellCount: 0,
        suppressedAll: false,
        truncated: false,
        generatedAt: now.toISOString(),
        warnings: [],
    },
    ...(error ? { error } : {}),
});
/** Chart kinds that read a free-text question rather than a set of buckets. */
export const TEXT_CHART_KINDS = ['textList', 'wordFrequency'];
/** Chart kinds that render a table rather than a plot. */
export const TABLE_CHART_KINDS = ['pivot', 'heatmap'];
/** Chart kinds that accept a second dimension as series or columns. */
export const TWO_DIMENSION_CHART_KINDS = [
    'stackedBar',
    'line',
    'area',
    'pivot',
    'heatmap',
];
